
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as faq4y1xxt_cbefNduOpSpPFauckC99Jv63pxp9NXX5Hqa8Meta } from "/codebuild/output/src601295675/src/src/pages/faq.vue?macro=true";
import { default as menujq050gH7Hq9c8bgiCEQejl5l2xrFW0rmLe_45tvTqAKnEMeta } from "/codebuild/output/src601295675/src/src/pages/menu.vue?macro=true";
import { default as indexmtFvFbtFrqNg5DmM4jSoDmU88meulWszEJF9FmZAQXsMeta } from "/codebuild/output/src601295675/src/src/pages/index.vue?macro=true";
import { default as contactySORX8NSMwrRtT4_45R6CMB_ZxhPZm6eSWt9_q78_nzm4Meta } from "/codebuild/output/src601295675/src/src/pages/contact.vue?macro=true";
import { default as tutorialEX7iPACaUQrEijvIsl4DC7Y54dhitZZmC7NiO83e4D0Meta } from "/codebuild/output/src601295675/src/src/pages/tutorial.vue?macro=true";
import { default as agreementyr_CB1FIsY3cZXenUtbSXRKaGJCUkmqq9BhAVgwFTH8Meta } from "/codebuild/output/src601295675/src/src/pages/agreement.vue?macro=true";
import { default as about_45passfwPizP0HjGAysWDOihO_CwDDHs3mkE61_45xPamGBM0cYMeta } from "/codebuild/output/src601295675/src/src/pages/about-pass.vue?macro=true";
import { default as index_45CpOOK9BPPL0oY3Zdp2As7J3NaIXSm92RtW7zaECYEkMeta } from "/codebuild/output/src601295675/src/src/pages/card/index.vue?macro=true";
import { default as _91id_93WtXCSkugtWDAtqAvtXajauhM3pU8muIz_xhB1FRgLr0Meta } from "/codebuild/output/src601295675/src/src/pages/coupon/[id].vue?macro=true";
import { default as maintenancexWg40CQjP1OBViZKJxC61SAaORbaVCoXLGcrmh_0u3cMeta } from "/codebuild/output/src601295675/src/src/pages/maintenance.vue?macro=true";
import { default as _91id_93oWfnu8GJIYGlQJeMfNcK5iiR5GTBZKULjiR50japDx8Meta } from "/codebuild/output/src601295675/src/src/pages/notice/[id].vue?macro=true";
import { default as index_45aaZKWq1qZ1KFKysW6I3m7OQdSS2DHrG2ni5_LlBJRcMeta } from "/codebuild/output/src601295675/src/src/pages/coupon/index.vue?macro=true";
import { default as indexdVSuOF6KIaZF8BUwAG76E7nB6dtssIaFtkZy8UBoxnUMeta } from "/codebuild/output/src601295675/src/src/pages/mypage/index.vue?macro=true";
import { default as indexF0UpSjd_45MUEc3u09Bxw6Ug1QgrgacAYwcMUuPJ913D4Meta } from "/codebuild/output/src601295675/src/src/pages/notice/index.vue?macro=true";
import { default as _91id_93VaZ_NhxLOAmye76GzkZAteIwFvVYZTLDCfy2mdUwA8YMeta } from "/codebuild/output/src601295675/src/src/pages/parking/[id].vue?macro=true";
import { default as index9xmR3XQhzZS6BwecaqsThmM49Qfue7wKKds3LfaWFmwMeta } from "/codebuild/output/src601295675/src/src/pages/history/index.vue?macro=true";
import { default as index15JHxH291ZGY2KGZu3xrBawxlCo_oy3SQGe_4JETesQMeta } from "/codebuild/output/src601295675/src/src/pages/monthly/index.vue?macro=true";
import { default as indexkgEeoSXujczqDhjd1NJf4vLmRe0jFj_45lhZAc1hosMUYMeta } from "/codebuild/output/src601295675/src/src/pages/sign-in/index.vue?macro=true";
import { default as indexnkiuCtX76G9fjk9RYQHmUAzQM2apjoC0VCzzno9eo54Meta } from "/codebuild/output/src601295675/src/src/pages/sign-up/index.vue?macro=true";
import { default as about_45yumenavinYm0LdJAqTiZS90y54v9pzxWaCrE27JjQY5_9yoTvZcMeta } from "/codebuild/output/src601295675/src/src/pages/about-yumenavi.vue?macro=true";
import { default as edithK0SvMWgGifOQTDSiaNR0kgnnGLrfkBVH1PUa6MwEZEMeta } from "/codebuild/output/src601295675/src/src/pages/card/[id]/edit.vue?macro=true";
import { default as pass_45agreement8wDIcMimFVgmmzF0pjU2pYnxzOFmC24_TSNJ5DGnW5oMeta } from "/codebuild/output/src601295675/src/src/pages/pass-agreement.vue?macro=true";
import { default as indexzUj74N0d2Kaj4cPgDO1ii69abfbzJh1mjFLjXFMzebIMeta } from "/codebuild/output/src601295675/src/src/pages/card/[id]/index.vue?macro=true";
import { default as confirm_453dEyEkq7mELKu__45ELxMH0CYLGKymA6SgKpwJuqpfpwItkMeta } from "/codebuild/output/src601295675/src/src/pages/card/confirm-3d.vue?macro=true";
import { default as confirm7pLB_45eSj2UJcDN4NKi_45doiXBvI9Rfs4bG92n7UUuMDgMeta } from "/codebuild/output/src601295675/src/src/pages/card/[id]/confirm.vue?macro=true";
import { default as indexs9aa0UiTX54rsM5yASDaX7aLZL8REvbMCfE7GBuVU38Meta } from "/codebuild/output/src601295675/src/src/pages/card/create/index.vue?macro=true";
import { default as indexiIPZ3MXkmfqDFQI46zlPs9LKgnOPHu_45Msc_d6TTLhgQMeta } from "/codebuild/output/src601295675/src/src/pages/mypage/pass/index.vue?macro=true";
import { default as confirmJaV3uXPGhWguNZaAV4yiDMJSbTLMqkWX1ZVJKvNUNnoMeta } from "/codebuild/output/src601295675/src/src/pages/membership/confirm.vue?macro=true";
import { default as confirmoV3spFfgujNGyza6DMIZvsKRp3gdXDOBCB6pmc81S0oMeta } from "/codebuild/output/src601295675/src/src/pages/card/create/confirm.vue?macro=true";
import { default as complete_45yZCX2rHxd2WWEl2oB_45xJ4NM1NQyUenGEgjVdiE7Ga4Meta } from "/codebuild/output/src601295675/src/src/pages/membership/complete.vue?macro=true";
import { default as registerdemMQa_n0q112WIGe6pXgTn0abMropeSTyrv3EhJKSwMeta } from "/codebuild/output/src601295675/src/src/pages/membership/register.vue?macro=true";
import { default as _91id_93yVgVdKtdEvtfXdPxixHFMkOIBE4DtxvSsdsGHnKNg54Meta } from "/codebuild/output/src601295675/src/src/pages/monthly/notice/[id].vue?macro=true";
import { default as confirm5L4yyOBv0rT1lvvvZ1wCpperqit62MwKmb7_SJPtRPAMeta } from "/codebuild/output/src601295675/src/src/pages/contact-form/confirm.vue?macro=true";
import { default as _91id_93yePpBZDYBAgCo7xOQePpx5f1ppE3oNwWDyyElT7JWM4Meta } from "/codebuild/output/src601295675/src/src/pages/history/receipt/[id].vue?macro=true";
import { default as indexgWUsIn4NYFxzlaVybBV8FiZ1J3UB_10jCVCLMctXwBUMeta } from "/codebuild/output/src601295675/src/src/pages/monthly/notice/index.vue?macro=true";
import { default as confirm_45codejwlLtSnCdiAg0eyl_dq629VawEIsUuEH36FeDysg_45HoMeta } from "/codebuild/output/src601295675/src/src/pages/sign-in/confirm-code.vue?macro=true";
import { default as confirm_45codebCjGH1jT9t0lVwgRu1A3Sf4SF9713pipvfx9RoH_45hdsMeta } from "/codebuild/output/src601295675/src/src/pages/sign-up/confirm-code.vue?macro=true";
import { default as completeKOeoqFoJmwpJkbJlSuuPSQTs9On0Bw6EGhaeoj46ppwMeta } from "/codebuild/output/src601295675/src/src/pages/contact-form/complete.vue?macro=true";
import { default as registersH9EXZ3gPE0t02nma0WhWe6YDVVdXoaz4_XRxlSRTJgMeta } from "/codebuild/output/src601295675/src/src/pages/contact-form/register.vue?macro=true";
import { default as completeCtUth5ELhb9_6sd92ocgyyJ5f7x0H5EqlC5hoc2GaNQMeta } from "/codebuild/output/src601295675/src/src/pages/monthly/cancel/complete.vue?macro=true";
import { default as indexgq6j9X1bM3fo57D0WcVdw2hbSJevM3aXspBY2F9ECxQMeta } from "/codebuild/output/src601295675/src/src/pages/mypage/membership/index.vue?macro=true";
import { default as confirmm4SZyhY_45EJFu_PfUJqbmyCMDPHxZKNFek_FSjX_45is04Meta } from "/codebuild/output/src601295675/src/src/pages/mypage/sign-out/confirm.vue?macro=true";
import { default as completevvYetX3Z4SpfwdI_VL_WD3T_czzs8auelwb_45_45zhJOCkMeta } from "/codebuild/output/src601295675/src/src/pages/reset-password/complete.vue?macro=true";
import { default as indexQpSFaQNmyzGhojUCBtZ0wLaGqRpMvhwyNhZNywxXmP0Meta } from "/codebuild/output/src601295675/src/src/pages/mypage/integration/index.vue?macro=true";
import { default as _91id_93kPllEBErjq_45IA26VdNf8arree_45_45kNMTv5HPHCAjmGMEMeta } from "/codebuild/output/src601295675/src/src/pages/mypage/pass/receipt/[id].vue?macro=true";
import { default as completetGsXP8sBHIfxTHzr6g9an2QGKBYhEezjA3ziSoA47JQMeta } from "/codebuild/output/src601295675/src/src/pages/mypage/sign-out/complete.vue?macro=true";
import { default as edit_45card_45aliasi161_r20IyW_45C3G6_FGSglnaeGLs1g0nA4Sn8jhHNEwMeta } from "/codebuild/output/src601295675/src/src/pages/card/[id]/edit-card-alias.vue?macro=true";
import { default as samplegz0Mvvvhis4ye6hTMWkHy1_6E3vc9AE2VsTINPe14EEMeta } from "/codebuild/output/src601295675/src/src/pages/mypage/integration/sample.vue?macro=true";
import { default as send_45emailUANOs2d7uprDiA25fCwFVa8xzhBtcjLm_cP_452wrSg64Meta } from "/codebuild/output/src601295675/src/src/pages/reset-password/send-email.vue?macro=true";
import { default as confirmmDtCZxzune1Rgc4wuzL7uRXV35Gq3eP0208i0YmehsAMeta } from "/codebuild/output/src601295675/src/src/pages/mypage/unsubscribe/confirm.vue?macro=true";
import { default as consentJ8_32TUg7iaVFRfspHG6mU00WK2SQK64rNFA_aP9pLcMeta } from "/codebuild/output/src601295675/src/src/pages/mypage/unsubscribe/consent.vue?macro=true";
import { default as confirma3zp60MjH72jYdM1Em7uxTKHx7lWPzA7S00fBwn7FGgMeta } from "/codebuild/output/src601295675/src/src/pages/membership/yumenavi/confirm.vue?macro=true";
import { default as duedateejJQswN2HFGB6izQkzX8379uWPTPMe57uxQiDrwipukMeta } from "/codebuild/output/src601295675/src/src/pages/monthly/application/duedate.vue?macro=true";
import { default as completeMhqNQsxFHBcj0jH7w5XDLyikkXvhzrtFR18h1gAWFuoMeta } from "/codebuild/output/src601295675/src/src/pages/mypage/unsubscribe/complete.vue?macro=true";
import { default as confirm_45codekzoW9o0vFzijIDX21VIMDZ6qWzAmd0U2MPUXjzkayUsMeta } from "/codebuild/output/src601295675/src/src/pages/reset-password/confirm-code.vue?macro=true";
import { default as new_45passwordmQkuwq5b5fp9IG_45vImvKhcTaiBjs_EBiY3mUgt_Jj1oMeta } from "/codebuild/output/src601295675/src/src/pages/reset-password/new-password.vue?macro=true";
import { default as confirm_45card_45alias2ABtCM2OoQTSUgE0D8k_459t0Uh_XMhOIY5rfScHtnbtIMeta } from "/codebuild/output/src601295675/src/src/pages/card/[id]/confirm-card-alias.vue?macro=true";
import { default as registerJHrnho4xLXpoXgarSN3K_b57Dy_MUOyR49KLqWFYP2YMeta } from "/codebuild/output/src601295675/src/src/pages/membership/yumenavi/register.vue?macro=true";
import { default as confirm_45codeVFqkqY1lPnpK0C_45JtyuK8bL_t94IMO7dEOzaHVceIREMeta } from "/codebuild/output/src601295675/src/src/pages/membership/yumenavi/confirm-code.vue?macro=true";
import { default as indexQG6jSTgcDpr_455sW__45Ohkp3MV8Y7x8bnO583I_Gio4LIMeta } from "/codebuild/output/src601295675/src/src/pages/mypage/membership/email-edit/index.vue?macro=true";
import { default as indexg7AZsCKMimY53GQ1W8icyG8nAuvy_YaFdzrZir_45cuykMeta } from "/codebuild/output/src601295675/src/src/pages/monthly/close/[applicationId]/index.vue?macro=true";
import { default as index1hfJ_45pLhj9sNhO_EO_452zgWdtk24aZWrT_hfBIISYkJYMeta } from "/codebuild/output/src601295675/src/src/pages/mypage/membership/others-edit/index.vue?macro=true";
import { default as indexQr3Gq2FcWOpg8JZJDgaQXkhPI1XI_451Gryvh_45RNAr84EMeta } from "/codebuild/output/src601295675/src/src/pages/monthly/cancel/[applicationId]/index.vue?macro=true";
import { default as updateye7HMFIY5j62QZQRK8Vl83OmZtgJu9yEDf4J7PoPCb0Meta } from "/codebuild/output/src601295675/src/src/pages/mypage/membership/others-edit/update.vue?macro=true";
import { default as completenlUVh_45coPHcqnO22ntP90v8NrDLoQolyQOI14YUUGR4Meta } from "/codebuild/output/src601295675/src/src/pages/mypage/membership/email-edit/complete.vue?macro=true";
import { default as confirmtfOawZWj7fLIr9WgldfKUC5gfztGF0x0D0BPstaVF4cMeta } from "/codebuild/output/src601295675/src/src/pages/mypage/membership/others-edit/confirm.vue?macro=true";
import { default as indexCdhSmdF2XAQ68xJ_WoP_gTy_KOyExQ5ye2hIJCcjRU4Meta } from "/codebuild/output/src601295675/src/src/pages/monthly/payments/[applicationId]/index.vue?macro=true";
import { default as completeDpOViM2VFQ7Hm_I79CZL2FTxX_45vL11VRC67O_JQY9RYMeta } from "/codebuild/output/src601295675/src/src/pages/mypage/membership/others-edit/complete.vue?macro=true";
import { default as update_45tVznV_458bujJo1OgHlqY3_UNzILzxe8CVJcCI4YfP5oMeta } from "/codebuild/output/src601295675/src/src/pages/mypage/membership/password-edit/update.vue?macro=true";
import { default as indexIBCO2BcNOQYWOa_Kyx0I9uPsU53n7VbhLGXW8fndD3MMeta } from "/codebuild/output/src601295675/src/src/pages/monthly/applicant/[applicationId]/index.vue?macro=true";
import { default as indexFisYjcr74IMSnWLgbc_4557_OS4qfB8_45fd27l8miW2JQAMeta } from "/codebuild/output/src601295675/src/src/pages/monthly/preapplication/[parkingId]/index.vue?macro=true";
import { default as completeRr5TNFSQZNlIUQnBtPw_Ty0gddPVF39d12gR4r5RqDEMeta } from "/codebuild/output/src601295675/src/src/pages/mypage/membership/password-edit/complete.vue?macro=true";
import { default as indexBbEo4lYcCW45wF4CseiviCdPmbosho38BY60Ve2Be6AMeta } from "/codebuild/output/src601295675/src/src/pages/monthly/application/[applicationId]/index.vue?macro=true";
import { default as confirm_45codeXhHJNWxc_45WboA01FKov4iUXAc_naPPd_D3Xn1QiBaswMeta } from "/codebuild/output/src601295675/src/src/pages/mypage/membership/email-edit/confirm-code.vue?macro=true";
import { default as indexpQeKOr6WQ4LmJsxv8Saab5AQ1VqsOEG549C6deQSo_45UMeta } from "/codebuild/output/src601295675/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue?macro=true";
import { default as indexVt19HUN7qeTA9BPlKDsZeam2pUV3kEmuP3gafoC3ScoMeta } from "/codebuild/output/src601295675/src/src/pages/monthly/payments/method/[applicationId]/index.vue?macro=true";
import { default as indexekPYEj_45n5xKCMgPxpsa5BsONvcVoXuVlkjUb8Hi_45AQQMeta } from "/codebuild/output/src601295675/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue?macro=true";
import { default as updatekjGnZZRbMr6UXqni8O_45Jr0dAODh6uDifzZAd7HhqMi4Meta } from "/codebuild/output/src601295675/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue?macro=true";
import { default as confirmEwOaf8i1LCkxZKY30mjbiWDeYppcFAbqqi72iaKJc_45kMeta } from "/codebuild/output/src601295675/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue?macro=true";
export default [
  {
    name: "faq",
    path: "/faq",
    component: () => import("/codebuild/output/src601295675/src/src/pages/faq.vue")
  },
  {
    name: "menu",
    path: "/menu",
    meta: menujq050gH7Hq9c8bgiCEQejl5l2xrFW0rmLe_45tvTqAKnEMeta || {},
    component: () => import("/codebuild/output/src601295675/src/src/pages/menu.vue")
  },
  {
    name: "index",
    path: "/",
    meta: { ...(indexmtFvFbtFrqNg5DmM4jSoDmU88meulWszEJF9FmZAQXsMeta || {}), ...{"middleware":["search-params"]} },
    component: () => import("/codebuild/output/src601295675/src/src/pages/index.vue")
  },
  {
    name: "contact",
    path: "/contact",
    component: () => import("/codebuild/output/src601295675/src/src/pages/contact.vue")
  },
  {
    name: "tutorial",
    path: "/tutorial",
    component: () => import("/codebuild/output/src601295675/src/src/pages/tutorial.vue")
  },
  {
    name: "agreement",
    path: "/agreement",
    component: () => import("/codebuild/output/src601295675/src/src/pages/agreement.vue")
  },
  {
    name: "about-pass",
    path: "/about-pass",
    component: () => import("/codebuild/output/src601295675/src/src/pages/about-pass.vue")
  },
  {
    name: "card",
    path: "/card",
    component: () => import("/codebuild/output/src601295675/src/src/pages/card/index.vue")
  },
  {
    name: "coupon-id",
    path: "/coupon/:id()",
    component: () => import("/codebuild/output/src601295675/src/src/pages/coupon/[id].vue")
  },
  {
    name: "maintenance",
    path: "/maintenance",
    component: () => import("/codebuild/output/src601295675/src/src/pages/maintenance.vue")
  },
  {
    name: "notice-id",
    path: "/notice/:id()",
    component: () => import("/codebuild/output/src601295675/src/src/pages/notice/[id].vue")
  },
  {
    name: "coupon",
    path: "/coupon",
    meta: { ...(index_45aaZKWq1qZ1KFKysW6I3m7OQdSS2DHrG2ni5_LlBJRcMeta || {}), ...{"middleware":["coupon-params"]} },
    component: () => import("/codebuild/output/src601295675/src/src/pages/coupon/index.vue")
  },
  {
    name: "mypage",
    path: "/mypage",
    meta: {"middleware":"unsubscribe-store-control"},
    component: () => import("/codebuild/output/src601295675/src/src/pages/mypage/index.vue")
  },
  {
    name: "notice",
    path: "/notice",
    meta: {"middleware":["notice-params"]},
    component: () => import("/codebuild/output/src601295675/src/src/pages/notice/index.vue")
  },
  {
    name: "parking-id",
    path: "/parking/:id()",
    meta: {"middleware":["set-redirect-url","payment-step"]},
    component: () => import("/codebuild/output/src601295675/src/src/pages/parking/[id].vue")
  },
  {
    name: "history",
    path: "/history",
    meta: { ...(index9xmR3XQhzZS6BwecaqsThmM49Qfue7wKKds3LfaWFmwMeta || {}), ...{"middleware":["payment-params"]} },
    component: () => import("/codebuild/output/src601295675/src/src/pages/history/index.vue")
  },
  {
    name: "monthly",
    path: "/monthly",
    component: () => import("/codebuild/output/src601295675/src/src/pages/monthly/index.vue")
  },
  {
    name: "sign-in",
    path: "/sign-in",
    meta: indexkgEeoSXujczqDhjd1NJf4vLmRe0jFj_45lhZAc1hosMUYMeta || {},
    component: () => import("/codebuild/output/src601295675/src/src/pages/sign-in/index.vue")
  },
  {
    name: "sign-up",
    path: "/sign-up",
    meta: indexnkiuCtX76G9fjk9RYQHmUAzQM2apjoC0VCzzno9eo54Meta || {},
    component: () => import("/codebuild/output/src601295675/src/src/pages/sign-up/index.vue")
  },
  {
    name: "about-yumenavi",
    path: "/about-yumenavi",
    component: () => import("/codebuild/output/src601295675/src/src/pages/about-yumenavi.vue")
  },
  {
    name: "card-id-edit",
    path: "/card/:id()/edit",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src601295675/src/src/pages/card/[id]/edit.vue")
  },
  {
    name: "pass-agreement",
    path: "/pass-agreement",
    component: () => import("/codebuild/output/src601295675/src/src/pages/pass-agreement.vue")
  },
  {
    name: "card-id",
    path: "/card/:id()",
    component: () => import("/codebuild/output/src601295675/src/src/pages/card/[id]/index.vue")
  },
  {
    name: "card-confirm-3d",
    path: "/card/confirm-3d",
    component: () => import("/codebuild/output/src601295675/src/src/pages/card/confirm-3d.vue")
  },
  {
    name: "card-id-confirm",
    path: "/card/:id()/confirm",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src601295675/src/src/pages/card/[id]/confirm.vue")
  },
  {
    name: "card-create",
    path: "/card/create",
    meta: indexs9aa0UiTX54rsM5yASDaX7aLZL8REvbMCfE7GBuVU38Meta || {},
    component: () => import("/codebuild/output/src601295675/src/src/pages/card/create/index.vue")
  },
  {
    name: "mypage-pass",
    path: "/mypage/pass",
    meta: {"middleware":["pass-payment-params"]},
    component: () => import("/codebuild/output/src601295675/src/src/pages/mypage/pass/index.vue")
  },
  {
    name: "membership-confirm",
    path: "/membership/confirm",
    meta: confirmJaV3uXPGhWguNZaAV4yiDMJSbTLMqkWX1ZVJKvNUNnoMeta || {},
    component: () => import("/codebuild/output/src601295675/src/src/pages/membership/confirm.vue")
  },
  {
    name: "card-create-confirm",
    path: "/card/create/confirm",
    meta: { ...(confirmoV3spFfgujNGyza6DMIZvsKRp3gdXDOBCB6pmc81S0oMeta || {}), ...{"middleware":["editing-card"]} },
    component: () => import("/codebuild/output/src601295675/src/src/pages/card/create/confirm.vue")
  },
  {
    name: "membership-complete",
    path: "/membership/complete",
    meta: complete_45yZCX2rHxd2WWEl2oB_45xJ4NM1NQyUenGEgjVdiE7Ga4Meta || {},
    component: () => import("/codebuild/output/src601295675/src/src/pages/membership/complete.vue")
  },
  {
    name: "membership-register",
    path: "/membership/register",
    meta: registerdemMQa_n0q112WIGe6pXgTn0abMropeSTyrv3EhJKSwMeta || {},
    component: () => import("/codebuild/output/src601295675/src/src/pages/membership/register.vue")
  },
  {
    name: "monthly-notice-id",
    path: "/monthly/notice/:id()",
    component: () => import("/codebuild/output/src601295675/src/src/pages/monthly/notice/[id].vue")
  },
  {
    name: "contact-form-confirm",
    path: "/contact-form/confirm",
    meta: confirm5L4yyOBv0rT1lvvvZ1wCpperqit62MwKmb7_SJPtRPAMeta || {},
    component: () => import("/codebuild/output/src601295675/src/src/pages/contact-form/confirm.vue")
  },
  {
    name: "history-receipt-id",
    path: "/history/receipt/:id()",
    component: () => import("/codebuild/output/src601295675/src/src/pages/history/receipt/[id].vue")
  },
  {
    name: "monthly-notice",
    path: "/monthly/notice",
    component: () => import("/codebuild/output/src601295675/src/src/pages/monthly/notice/index.vue")
  },
  {
    name: "sign-in-confirm-code",
    path: "/sign-in/confirm-code",
    meta: confirm_45codejwlLtSnCdiAg0eyl_dq629VawEIsUuEH36FeDysg_45HoMeta || {},
    component: () => import("/codebuild/output/src601295675/src/src/pages/sign-in/confirm-code.vue")
  },
  {
    name: "sign-up-confirm-code",
    path: "/sign-up/confirm-code",
    meta: confirm_45codebCjGH1jT9t0lVwgRu1A3Sf4SF9713pipvfx9RoH_45hdsMeta || {},
    component: () => import("/codebuild/output/src601295675/src/src/pages/sign-up/confirm-code.vue")
  },
  {
    name: "contact-form-complete",
    path: "/contact-form/complete",
    meta: completeKOeoqFoJmwpJkbJlSuuPSQTs9On0Bw6EGhaeoj46ppwMeta || {},
    component: () => import("/codebuild/output/src601295675/src/src/pages/contact-form/complete.vue")
  },
  {
    name: "contact-form-register",
    path: "/contact-form/register",
    meta: registersH9EXZ3gPE0t02nma0WhWe6YDVVdXoaz4_XRxlSRTJgMeta || {},
    component: () => import("/codebuild/output/src601295675/src/src/pages/contact-form/register.vue")
  },
  {
    name: "monthly-cancel-complete",
    path: "/monthly/cancel/complete",
    component: () => import("/codebuild/output/src601295675/src/src/pages/monthly/cancel/complete.vue")
  },
  {
    name: "mypage-membership",
    path: "/mypage/membership",
    component: () => import("/codebuild/output/src601295675/src/src/pages/mypage/membership/index.vue")
  },
  {
    name: "mypage-sign-out-confirm",
    path: "/mypage/sign-out/confirm",
    meta: { ...(confirmm4SZyhY_45EJFu_PfUJqbmyCMDPHxZKNFek_FSjX_45is04Meta || {}), ...{"middleware":"logout-control"} },
    component: () => import("/codebuild/output/src601295675/src/src/pages/mypage/sign-out/confirm.vue")
  },
  {
    name: "reset-password-complete",
    path: "/reset-password/complete",
    meta: completevvYetX3Z4SpfwdI_VL_WD3T_czzs8auelwb_45_45zhJOCkMeta || {},
    component: () => import("/codebuild/output/src601295675/src/src/pages/reset-password/complete.vue")
  },
  {
    name: "mypage-integration",
    path: "/mypage/integration",
    meta: { ...(indexQpSFaQNmyzGhojUCBtZ0wLaGqRpMvhwyNhZNywxXmP0Meta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src601295675/src/src/pages/mypage/integration/index.vue")
  },
  {
    name: "mypage-pass-receipt-id",
    path: "/mypage/pass/receipt/:id()",
    component: () => import("/codebuild/output/src601295675/src/src/pages/mypage/pass/receipt/[id].vue")
  },
  {
    name: "mypage-sign-out-complete",
    path: "/mypage/sign-out/complete",
    meta: completetGsXP8sBHIfxTHzr6g9an2QGKBYhEezjA3ziSoA47JQMeta || {},
    component: () => import("/codebuild/output/src601295675/src/src/pages/mypage/sign-out/complete.vue")
  },
  {
    name: "card-id-edit-card-alias",
    path: "/card/:id()/edit-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src601295675/src/src/pages/card/[id]/edit-card-alias.vue")
  },
  {
    name: "mypage-integration-sample",
    path: "/mypage/integration/sample",
    meta: { ...(samplegz0Mvvvhis4ye6hTMWkHy1_6E3vc9AE2VsTINPe14EEMeta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src601295675/src/src/pages/mypage/integration/sample.vue")
  },
  {
    name: "reset-password-send-email",
    path: "/reset-password/send-email",
    meta: send_45emailUANOs2d7uprDiA25fCwFVa8xzhBtcjLm_cP_452wrSg64Meta || {},
    component: () => import("/codebuild/output/src601295675/src/src/pages/reset-password/send-email.vue")
  },
  {
    name: "mypage-unsubscribe-confirm",
    path: "/mypage/unsubscribe/confirm",
    meta: { ...(confirmmDtCZxzune1Rgc4wuzL7uRXV35Gq3eP0208i0YmehsAMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src601295675/src/src/pages/mypage/unsubscribe/confirm.vue")
  },
  {
    name: "mypage-unsubscribe-consent",
    path: "/mypage/unsubscribe/consent",
    meta: { ...(consentJ8_32TUg7iaVFRfspHG6mU00WK2SQK64rNFA_aP9pLcMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src601295675/src/src/pages/mypage/unsubscribe/consent.vue")
  },
  {
    name: "membership-yumenavi-confirm",
    path: "/membership/yumenavi/confirm",
    meta: confirma3zp60MjH72jYdM1Em7uxTKHx7lWPzA7S00fBwn7FGgMeta || {},
    component: () => import("/codebuild/output/src601295675/src/src/pages/membership/yumenavi/confirm.vue")
  },
  {
    name: "monthly-application-duedate",
    path: "/monthly/application/duedate",
    component: () => import("/codebuild/output/src601295675/src/src/pages/monthly/application/duedate.vue")
  },
  {
    name: "mypage-unsubscribe-complete",
    path: "/mypage/unsubscribe/complete",
    meta: { ...(completeMhqNQsxFHBcj0jH7w5XDLyikkXvhzrtFR18h1gAWFuoMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src601295675/src/src/pages/mypage/unsubscribe/complete.vue")
  },
  {
    name: "reset-password-confirm-code",
    path: "/reset-password/confirm-code",
    meta: confirm_45codekzoW9o0vFzijIDX21VIMDZ6qWzAmd0U2MPUXjzkayUsMeta || {},
    component: () => import("/codebuild/output/src601295675/src/src/pages/reset-password/confirm-code.vue")
  },
  {
    name: "reset-password-new-password",
    path: "/reset-password/new-password",
    meta: new_45passwordmQkuwq5b5fp9IG_45vImvKhcTaiBjs_EBiY3mUgt_Jj1oMeta || {},
    component: () => import("/codebuild/output/src601295675/src/src/pages/reset-password/new-password.vue")
  },
  {
    name: "card-id-confirm-card-alias",
    path: "/card/:id()/confirm-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src601295675/src/src/pages/card/[id]/confirm-card-alias.vue")
  },
  {
    name: "membership-yumenavi-register",
    path: "/membership/yumenavi/register",
    meta: registerJHrnho4xLXpoXgarSN3K_b57Dy_MUOyR49KLqWFYP2YMeta || {},
    component: () => import("/codebuild/output/src601295675/src/src/pages/membership/yumenavi/register.vue")
  },
  {
    name: "membership-yumenavi-confirm-code",
    path: "/membership/yumenavi/confirm-code",
    meta: confirm_45codeVFqkqY1lPnpK0C_45JtyuK8bL_t94IMO7dEOzaHVceIREMeta || {},
    component: () => import("/codebuild/output/src601295675/src/src/pages/membership/yumenavi/confirm-code.vue")
  },
  {
    name: "mypage-membership-email-edit",
    path: "/mypage/membership/email-edit",
    component: () => import("/codebuild/output/src601295675/src/src/pages/mypage/membership/email-edit/index.vue")
  },
  {
    name: "monthly-close-applicationId",
    path: "/monthly/close/:applicationId()",
    component: () => import("/codebuild/output/src601295675/src/src/pages/monthly/close/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit",
    path: "/mypage/membership/others-edit",
    component: () => import("/codebuild/output/src601295675/src/src/pages/mypage/membership/others-edit/index.vue")
  },
  {
    name: "monthly-cancel-applicationId",
    path: "/monthly/cancel/:applicationId()",
    component: () => import("/codebuild/output/src601295675/src/src/pages/monthly/cancel/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-update",
    path: "/mypage/membership/others-edit/update",
    component: () => import("/codebuild/output/src601295675/src/src/pages/mypage/membership/others-edit/update.vue")
  },
  {
    name: "mypage-membership-email-edit-complete",
    path: "/mypage/membership/email-edit/complete",
    component: () => import("/codebuild/output/src601295675/src/src/pages/mypage/membership/email-edit/complete.vue")
  },
  {
    name: "mypage-membership-others-edit-confirm",
    path: "/mypage/membership/others-edit/confirm",
    component: () => import("/codebuild/output/src601295675/src/src/pages/mypage/membership/others-edit/confirm.vue")
  },
  {
    name: "monthly-payments-applicationId",
    path: "/monthly/payments/:applicationId()",
    component: () => import("/codebuild/output/src601295675/src/src/pages/monthly/payments/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-complete",
    path: "/mypage/membership/others-edit/complete",
    component: () => import("/codebuild/output/src601295675/src/src/pages/mypage/membership/others-edit/complete.vue")
  },
  {
    name: "mypage-membership-password-edit-update",
    path: "/mypage/membership/password-edit/update",
    component: () => import("/codebuild/output/src601295675/src/src/pages/mypage/membership/password-edit/update.vue")
  },
  {
    name: "monthly-applicant-applicationId",
    path: "/monthly/applicant/:applicationId()",
    component: () => import("/codebuild/output/src601295675/src/src/pages/monthly/applicant/[applicationId]/index.vue")
  },
  {
    name: "monthly-preapplication-parkingId",
    path: "/monthly/preapplication/:parkingId()",
    component: () => import("/codebuild/output/src601295675/src/src/pages/monthly/preapplication/[parkingId]/index.vue")
  },
  {
    name: "mypage-membership-password-edit-complete",
    path: "/mypage/membership/password-edit/complete",
    component: () => import("/codebuild/output/src601295675/src/src/pages/mypage/membership/password-edit/complete.vue")
  },
  {
    name: "monthly-application-applicationId",
    path: "/monthly/application/:applicationId()",
    component: () => import("/codebuild/output/src601295675/src/src/pages/monthly/application/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-email-edit-confirm-code",
    path: "/mypage/membership/email-edit/confirm-code",
    component: () => import("/codebuild/output/src601295675/src/src/pages/mypage/membership/email-edit/confirm-code.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi",
    path: "/mypage/membership/others-edit/yumenavi",
    component: () => import("/codebuild/output/src601295675/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue")
  },
  {
    name: "monthly-payments-method-applicationId",
    path: "/monthly/payments/method/:applicationId()",
    component: () => import("/codebuild/output/src601295675/src/src/pages/monthly/payments/method/[applicationId]/index.vue")
  },
  {
    name: "monthly-renewalcontract-applicationId",
    path: "/monthly/renewalcontract/:applicationId()",
    component: () => import("/codebuild/output/src601295675/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-update",
    path: "/mypage/membership/others-edit/yumenavi/update",
    component: () => import("/codebuild/output/src601295675/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-confirm",
    path: "/mypage/membership/others-edit/yumenavi/confirm",
    component: () => import("/codebuild/output/src601295675/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue")
  }
]